import {connect} from 'react-redux';
import WorkDataStepView from '../../../components/views/mx/creditoReal/WorkDataStepView';
import * as LoanApplicationActions from '../../../actions/LoanApplicationActions';
import * as WizardActions from '../../../actions/WizardActions';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import { withRouter } from 'react-router';
import {MX_VALUES} from '../../../constants/MX/WizardInputs';
import {FormFieldProps} from '../../../../common/types/components';
import * as WizardValidationUtils from '../../../utils/WizardValidationUtils';
import {State} from '../../../types/mx/reducers';
import {pushDataLayer} from '../../../../common/utils/GTMUtils';
import {DATA_LAYER} from '../../../../common/constants/LabelConstants';
import * as ValidateConstant from '../../../constants/ValidateConstant';
import {CR_DEPENDENT_CATALOG_ID} from '../../../constants/MotorcreditConstants';
import {relationshipTypeSelector} from '../../../selectors/creditoReal/applicantHome';

const mapStateToProps = (state : State, {match}) => {
    const employment = state.creditoReal.loanApplication.applicantEmployment;
    const workStepViewState = state.creditoReal.ui.workDataStepView.fieldErrors;
    const employmentTypesState = state.catalogs.employmentTypes;
    const crDocumentTypeCatalog = state.catalogs.crDocumentType;
    const crBusinessTypeCatalog = state.catalogs.crBusinessType;
    return {
        crBusinessTypeCatalog,
        crDocumentTypeCatalog: crDocumentTypeCatalog.filter(x => x.id !== '0'),
        workplaceNameField: new FormFieldProps(employment.workplaceName,
            workStepViewState.workplaceNameFieldError),
        positionField: new FormFieldProps(employment.position, workStepViewState.positionFieldError),
        workingSinceField: new FormFieldProps(employment.workingSince, workStepViewState.workingSinceFieldError),
        addressField: new FormFieldProps(employment.address, workStepViewState.addressFieldError),
        extNumberField: new FormFieldProps(employment.extNumber, workStepViewState.extNumberFieldError),
        postalCodeField: new FormFieldProps(employment.postalCode, workStepViewState.postalCodeFieldError),
        stateField: new FormFieldProps(WizardValidationUtils.getCatalogValue(employment.state),
            workStepViewState.stateFieldError),
        cityField: new FormFieldProps(WizardValidationUtils.getCatalogValue(employment.city),
            workStepViewState.cityFieldError),
        municipalityField: new FormFieldProps(WizardValidationUtils.getCatalogValue(employment.municipality),
            workStepViewState.municipalityFieldError),
        colonyField: new FormFieldProps(employment.selectedColony, workStepViewState.selectedColonyFieldError),
        workplacePhoneField: new FormFieldProps(employment.workplacePhone,
            workStepViewState.workplacePhoneFieldError),
        intNumberField: new FormFieldProps(employment.intNumber),
        workplacePhoneExtField: new FormFieldProps(employment.workplacePhoneExt),
        monthlyIncomesField: new FormFieldProps(employment.monthlyIncomes,
            workStepViewState.monthlyIncomesFieldError),
        countrySelected: state.countrySelector.countrySelected,
        booleanOptions: MX_VALUES.BOOLEAN_VALUES,
        loanApplicationToken: match.params.token,
        colonies: employment.colonies,
        includeMonthlyIncomesField: new FormFieldProps(employment.includeMonthlyIncomes),
        workDataFieldsHasError: WizardValidationUtils.workDataFieldHasError(
            workStepViewState.workplaceNameFieldError,
            workStepViewState.positionFieldError,
            workStepViewState.workingSinceFieldError,
            workStepViewState.addressFieldError,
            workStepViewState.extNumberFieldError,
            workStepViewState.postalCodeFieldError,
            workStepViewState.stateFieldError,
            workStepViewState.cityFieldError,
            workStepViewState.municipalityFieldError,
            workStepViewState.selectedColonyFieldError,
            workStepViewState.workplacePhoneFieldError,
            workStepViewState.monthlyIncomesFieldError,
            employment.includeMonthlyIncomes
        ),
        employmentTypes: employmentTypesState,
        employmentTypesField: new FormFieldProps(relationshipTypeSelector(state)),
        documentTypeSelectedField: new FormFieldProps(employment.documentType,
            workStepViewState.documentTypeFieldError),
        businessTypeSelectedField: new FormFieldProps(employment.businessType,
            workStepViewState.businessTypeFieldError),
        yearSelected: state.creditoReal.calculator.yearSelected.value,
        postalCode: state.creditoReal.loanApplication.applicantHome.postalCode,
        versionSelected: state.creditoReal.calculator.versionSelected.payload,
        monthlyPayment: state.creditoReal.calculator.monthlyPayment,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeIncludeMonthlyIncomes: monthlyIncomes => (includeMonthlyIncomes) => {
            dispatch(
                WizardActions.CHANGE_INCLUDE_MONTHLY_INCOMES.action(includeMonthlyIncomes.payload, monthlyIncomes)
            );
            dispatch(WizardActions.CHANGE_EMPLOYMENT_DOCUMENT_TYPE_ACTION
                .action(undefined, includeMonthlyIncomes.payload ? ValidateConstant.ERROR_REQUIRED : null));
        },
        onPressNext: () => {
            pushDataLayer(DATA_LAYER.WORK);
            dispatch(WizardMXActions.SAVE_APPLICANT_EMPLOYMENT_MX_ACTION.action());
        },
        onChangeWorkplaceName: (workplaceName, error) =>
            dispatch(WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_NAME_ACTION.action(workplaceName, error)),
        onChangePosition: (position, error) =>
            dispatch(WizardActions.CHANGE_EMPLOYMENT_POSITION_ACTION.action(position, error)),
        onChangeWorkingSince: (workingSince, error) =>
            dispatch(WizardActions.CHANGE_EMPLOYMENT_WORKING_SINCE_ACTION.action(workingSince, error)),
        onChangeAddress: (address, error) =>
            dispatch(WizardActions.CHANGE_EMPLOYMENT_ADDRESS_ACTION.action(address, error)),
        onChangeExtNumber: (extNumber, error) =>
            dispatch(WizardActions.CHANGE_EMPLOYMENT_EXT_NUMBER_ACTION.action(extNumber, error)),
        onChangeIntNumber: (intNumber, error) =>
            dispatch(WizardActions.CHANGE_EMPLOYMENT_INT_NUMBER_ACTION.action(intNumber, error)),
        onChangePostalCode: country => (postalCode, error) =>
            dispatch(WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_ACTION.action(postalCode, country, error)),
        onChangeWorkplacePhone: (workplacePhone, error) =>
            dispatch(WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_PHONE_ACTION.action(workplacePhone, error)),
        onChangeWorkplacePhoneExt: (workplacePhoneExt, error) =>
            dispatch(WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_PHONE_EXT_ACTION.action(workplacePhoneExt, error)),
        onChangeMonthlyIncomes: (monthlyIncomes, error) =>
            dispatch(WizardActions.CHANGE_EMPLOYMENT_MONTHLY_INCOMES_ACTION.action(monthlyIncomes, error)),
        getAllQuotationInsurances: (year, statePostalCode, version, term) => () =>
            dispatch(LoanApplicationActions.GET_ALL_QUOTATION_INSURANCES_ACTION
                .action(year, statePostalCode, version, term)),
        onChangeColony: (colony, error) =>
            dispatch(WizardActions.CHANGE_EMPLOYMENT_COLONY_MX_ACTION.action(colony, error)),
        onPressBack: () => dispatch(WizardMXActions.GO_TO_PRIVACY_BUREAU_TERMS_MX_ACTION.action()),
        getLoanApplication: token => () =>
            dispatch(WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_ACTION.action(token)),
        onChangeEmploymentTypes: (employmentType) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_TYPES_INCOMES.action(employmentType, null));
            dispatch(WizardActions.CHANGE_EMPLOYMENT_BUSINESS_TYPE_ACTION
                .action(undefined, employmentType.id === CR_DEPENDENT_CATALOG_ID ?
                    null : ValidateConstant.ERROR_REQUIRED));
        },
        onChangeDocumentType: (documentType, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_DOCUMENT_TYPE_ACTION.action(documentType, error));
        },
        onChangeBusinessType: (businessType, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_BUSINESS_TYPE_ACTION.action(businessType, error));
        },
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
        onChangePostalCode: dispatchProps.onChangePostalCode(stateProps.countrySelected),
        getAllQuotationInsurances: dispatchProps.getAllQuotationInsurances(
            stateProps.yearSelected,
            stateProps.postalCode,
            stateProps.versionSelected,
            stateProps.monthlyPayment.id,
        ),
        getLoanApplication: dispatchProps.getLoanApplication(stateProps.loanApplicationToken, stateProps.postalCode,
            stateProps.countrySelected),
        booleanOptions: stateProps.booleanOptions.map((item) => {
            if (item.payload) return {...item, defaultChecked: stateProps.monthlyIncomes > 0};
            return {...item, defaultChecked: stateProps.monthlyIncomes === 0};
        }),
        employmentTypes: stateProps.employmentTypes.map((item, index) => {
            return {...item, defaultChecked: index === 0, label: item.value};
        }),
        onChangeIncludeMonthlyIncomes: dispatchProps.onChangeIncludeMonthlyIncomes(
            stateProps.monthlyIncomesField.value
        )
    };
};

const WorkDataStepContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(WorkDataStepView));

export default WorkDataStepContainer;
